import { render, staticRenderFns } from "./MarketplaceDashboard.vue?vue&type=template&id=7c443a38&scoped=true&"
import script from "./MarketplaceDashboard.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c443a38",
  null
  
)

export default component.exports